/*@flow*/

export default async (req: Request, cacheName: string) => {
  if ('caches' in window) {
    const cache = await caches.open(cacheName);
    // TODO: handle POST requests
    const cacheRes = await cache.match(req);
    if (cacheRes) return cacheRes;
    const networkRes = await fetch(req);
    if (networkRes.status >= 200 && networkRes.status < 300) {
      cache.put(req, networkRes.clone());
    }
    return networkRes;
  }
  return fetch(req);
};
